import { cva } from '@/styled-system/css';

export const comboboxOptionRecipe = cva({
  base: {
    'display': 'block',
    'paddingBlock': 'Combobox.Option.padding.vert',
    'paddingInline': 'Combobox.Option.padding.horz',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: '{transitions.Combobox.Option}',
    },
    'width': '100%',
    'backgroundColor': { base: 'Combobox.Option.bg.default' },

    '&:has([data-c11n-component="Combobox.OptionMedia"])': {
      display: 'grid',
      gridTemplate: `
        "media label" auto
        "media meta" auto / auto auto
      `,
      justifyContent: 'start',
      columnGap: 'Combobox.Option.gap.leading',
    },

    '& [data-c11n-component="Highlight"]': {
      textStyle: 'body-bold',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        cursor: 'pointer',
        backgroundColor: {
          base: 'Combobox.Option.bg.default',
          _hover: 'Combobox.Option.bg.hover',
          _active: 'Combobox.Option.bg.pressed',
        },
      },
    },
    active: {
      true: {},
      false: {},
    },
    selected: {
      true: {
        backgroundColor: { base: 'Combobox.Option.bg.selected' },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      active: true,
      css: {
        backgroundColor: { base: 'Combobox.Option.bg.hover' },
      },
    },
  ],
});
